class TokenService {
  private readonly getter = (key: string) => {
    const value = localStorage.getItem(key);
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error(`Error parsing value for key "${key}":`, error);
      return null;
    }
  };

  private readonly setter = (key: string, token: unknown): void => {
    if (key && token !== undefined) {
      localStorage.setItem(key, JSON.stringify(token));
    }
  };

  getAccessToken(): string | null {
    return this.getter("accessToken");
  }

  getRefreshToken(): string | null {
    return this.getter("refreshToken");
  }

  getIdToken(): string | null {
    return this.getter("idToken");
  }

  setAccessToken(token: string): void {
    this.setter("accessToken", token);
  }

  setRefreshToken(token: string): void {
    this.setter("refreshToken", token);
  }

  setIdToken(token: string): void {
    this.setter("idToken", token);
  }

  removeToken(): void {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("idToken");
  }

  clearStorage(): void {
    localStorage.clear();
    sessionStorage.clear();
  }
}

export default new TokenService();
